import http from '@/api/HttpHelper'
import { saveAs } from 'file-saver'
import moment from 'moment'

const findYears = function () {
    const startYear = 2020
    const yearNow = moment().year()
    const years = []

    for (let year = yearNow; year >= startYear; year--) {
        years.push(year)
    }

    return years
}

const state = {
    loading: false,
    years: findYears(),
    selectedYear: moment().year(),
    branch: localStorage.getItem('branch') || '',
    data: []
}

const getters = {
    loading (state) {
        return state.loading
    },
    years (state) {
        return state.years
    },
    selectedYear (state) {
        return state.selectedYear
    },
    branch (state) {
        return state.branch
    },
    data (state) {
        return state.data
    }
}

const mutations = {
    setLoading (state, isLoading) {
        state.loading = isLoading
    },
    setSelectedYear (state, year) {
        state.selectedYear = year
    },
    setBranch (state, branch) {
        state.branch = branch
        localStorage.setItem('branch', branch)
    },
    data (state, data) {
        state.data = data
    }
}

const actions = {

    async getReportData ({commit, state}) {
        commit('setLoading', true)

        const params = {
            year: state.selectedYear,
            branch: state.branch
        }

        const result = await http.get('monthlytotals', {params: params})

        if (result.status == 200) {
            const {lines} = result.data
            commit('data', lines)
        }

        commit('setLoading', false)
    },
    async getReportFile () {
        const params = {
            year: state.selectedYear,
            branch: state.branch
        }
        const result = await http.get('monthlytotals/export', {params: params, responseType: 'blob'})

        if (result.status === 200)
            saveAs(result.data, 'saldo.xlsx')
    },
    setBranch ({ commit, dispatch }, branch) {
        commit('setBranch', branch)
        dispatch('getReportData')
    },
    setSelectedYear ({commit,dispatch}, year) {
        commit('setSelectedYear', year)
        dispatch('getReportData')
    },
    
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}